import { AxiosError, AxiosRequestConfig } from 'axios';
import { useEffect, useState } from 'react';
import { get } from '../api';
import { PaginatedResponse } from '../dtos/PaginatedResponse';

const useGetPaginatedData = <T>(url: string, axiosOptions?: AxiosRequestConfig) => {
    const [responseData, setResponseData] = useState<PaginatedResponse<T> | null>(null);
    const [error, setError] = useState<AxiosError>();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState<number>(0);
    const [abortController] = useState<AbortController>(new AbortController());
    const [specificPageLoc, setSpecificPageLoc] = useState(1);
    const [refresh, setRefresh] = useState(false);

    const getSpecificPage = (value: number | undefined) => {
        get(`${url}/${value}`, axiosOptions)
            .then((axiosRes) => {
                !axiosRes.data
                    ? setError(new AxiosError('Received null or undefined as a response'))
                    : setResponseData(axiosRes.data);
                setStatus(axiosRes.status);
            })
            .catch((error) => {
                const axErr = error as AxiosError;
                setError(axErr);
            })
            .finally(() => {
                setTimeout(() => setLoading(false), 1000);
            });
    };

    useEffect(() => {
        getSpecificPage(specificPageLoc);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specificPageLoc, refresh]);

    const paginationHandler = (ev: React.ChangeEvent<unknown>, value: number) => {
        setSpecificPageLoc(value);
        if (value !== specificPageLoc) {
            setResponseData(null);
        }
    };

    const refreshData = () => {
        setSpecificPageLoc(1);
        setRefresh((prev) => !prev);
        setResponseData(null);
    };

    return {
        data: responseData,
        loading,
        error,
        status,
        abortController,
        paginationHandler,
        refreshData
    };
};

export default useGetPaginatedData;
